// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"0904bf87","453":"a6e1fdb0"}[chunkId] + ".chunk.js";
};